import { Navigate } from "react-router-dom"

export const ProtectedRoutes = ({children, user}) => {
    return user ? children : <Navigate to="/" replace />;
} 
//Reroutes to defualt route if not user is detcted or trys to access pages that require a user 